import * as React from "react";
import { useState, useEffect } from "react";
import { useWindowSize } from "../../../../hooks/useWindowSize";
import { ISalesChannel } from "../../../../services/ecommerceApi/SalesChannel/types";
import GetComponent from "../../../websiteTemplates/_GetComponent";
import { HeaderProps } from "../../../websiteTemplates/Default/Header";
import { ImageDataLike } from "gatsby-plugin-image";
import { Menu } from "../Footer";
import DevTools from "../../../shared/devtools";

interface Props {
    pageTemplate: any;
    salesChannel: ISalesChannel;
    allMenus: Menu[]
}

const Header = ({ pageTemplate, salesChannel, allMenus }: Props) => {

    const logoFile = pageTemplate?.headerLogoFile as {
        node: ImageDataLike;
    }

    const headerMenus = pageTemplate?.header?.menus || [];
    const menus = headerMenus.map(menu => {
        const menuObj = allMenus.find(m => m.id === menu.id);
        if (menuObj) {
            return menuObj;
        }
        return menu;
    });

    const windowSize = useWindowSize();

    const [isSticky, setIsSticky] = useState(false);
    const [isDrawerVisible, setIsDrawerVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            setIsSticky(scrollTop > 0);
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const isMobile = React.useMemo(() => {
        return (windowSize?.width ?? 1000) < 768;
    }, [windowSize]);

    const headerProps: HeaderProps = {
        salesChannel,
        logoFile,
        isSticky,
        isDrawerVisible,
        setIsDrawerVisible,
        isMobile,
        windowSize,
        allMenus,
        menus
    }

    const template = salesChannel?.websiteTemplate;


    const isDevMode = process.env.GATSBY_SHOW_DEV_TOOLS === "true";

    return (
        <>

            {isDevMode && <DevTools />}
            <GetComponent template={template} component="Header" props={headerProps} />
        </>
    );
};

export default Header;
